import { TextField, Typography, Button, makeStyles, CircularProgress } from '@material-ui/core';
import { useState, useEffect } from "react";
import { useHistory} from "react-router-dom";
import { postRequest } from "../Helpers/RequestHelper";
var sha256 = require('js-sha256');

const ForcePasswordChangePage = () => {
    const [oldPassword, setOldPassword] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [loading, setLoading] = useState(false);

    const useStyles = makeStyles(theme => ({
        page: {
            paddingTop: 20,
            width: '80%',
            margin: 'auto'
        },
        formSection: {
            width: '100%',
            margin: '20px auto',
            position: 'relative'
        },
        buttonProgress: {
            color: 'white',
            position: 'absolute',
            top: '50%',
            left: '50%',
            marginTop: -12,
            marginLeft: -12,
        },
        root: {
            '&$disabled': {
                backgroundColor: theme.palette.primary.light,
                color: 'white'
            },
        },
        disabled: {}
    }));

    const classes = useStyles();
    const history = useHistory();

    useEffect(() => {
        document.title = 'Oxford Lymphoedema Practice - Change Password';
        if(localStorage.getItem('token') === "") {
            history.replace('/login');
            return;
        }
    }, []);

    const changeButtonPressed = (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        setSuccess('');
        if (password !== confirmPassword) {
            setError('Passwords must match');
            setLoading(false);
            return;
        }
        var hashedOld = sha256.hmac('Gbdsk64H2k', oldPassword);
        var hashedNew = sha256.hmac('Gbdsk64H2k', password);

        var passObj = {
            fieldData: {
                Message: "Changing password"
            },
            script: "ChangePasswordAuthenticated",
            "script.param": JSON.stringify({
                token: localStorage.getItem("token"),
                requestBody: {
                    oldPassword: hashedOld,
                    newPassword: hashedNew
                }
            })
        };

        postRequest(passObj)
            .then(function (result) {
                if (result.code === 200) {
                    setSuccess('Password changed successfully');
                    setLoading(false);
                    history.replace('/documents');
                    return;
                }
                setLoading(false);
                setError(result.message);
            })
            .catch(function (error) {
                setError('There was a problem resetting your password, please try again');
                setLoading(false);
            });

    }

    return (
        <div className={classes.page}>
            <form onSubmit={changeButtonPressed}>
                <div className={classes.formSection}>
                    <TextField style={{ width: '100%', backgroundColor: 'white', borderRadius: 5 }} type='password' variant='outlined' id='old-password' label='Current password' value={oldPassword} onChange={(e) => setOldPassword(e.currentTarget.value)} />
                </div>
                <div className={classes.formSection}>
                    <TextField style={{ width: '100%', backgroundColor: 'white', borderRadius: 5 }} type='password' variant='outlined' id='password' label='New password' value={password} onChange={(e) => setPassword(e.currentTarget.value)} />
                </div>
                <div className={classes.formSection}>
                    <TextField style={{ width: '100%', backgroundColor: 'white', borderRadius: 5 }} type='password' variant='outlined' id='confirm-password' label='Confirm New password' value={confirmPassword} onChange={(e) => setConfirmPassword(e.currentTarget.value)} />
                </div>
                <div className={classes.formSection}>
                    {error !== "" && <Typography style={{ color: 'red' }}>{error}</Typography>}
                </div>
                <div className={classes.formSection}>
                    {success !== "" && <Typography style={{ color: 'green' }}>{success}</Typography>}
                </div>
                <div className={classes.formSection}>
                    <Button type="submit" style={{ width: '100%', height: 60 }} variant="contained" color="primary" disabled={loading} classes={{ disabled: classes.disabled, root: classes.root }}>
                        Confirm Change
                    </Button>
                    {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                </div>
            </form>
        </div>
    );
}

export default ForcePasswordChangePage;